import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CmpsDialogRef } from '@cmps/ng-uikit';
import { tap } from 'rxjs/operators';

import {
    takeUntilDestroy,
    TakeUntilDestroy,
} from '../../../../common/take-until-destroy.decorator';
import { currentBuilderState } from '../../builder.state';
import { createJob } from '../../function/create-job.function';
import { BuilderState } from '../../model/builder-state.model';

@Component({
    selector: 'cmps-report-builder-schedule-dialog',
    templateUrl: './schedule-dialog.component.html',
})
@TakeUntilDestroy()
export class ScheduleDialogComponent {
    /** @private */
    _state: BuilderState;

    constructor(
        private readonly _router: Router,
        /** @private */ readonly _dialogRef: CmpsDialogRef<
            ScheduleDialogComponent,
            void
        >,
    ) {
        this._state = currentBuilderState();
    }

    /** @private */
    _onScheduleClick(): void {
        this._state.creatingJob = true;

        createJob()
            .pipe(
                tap((ret) => {
                    this._state.creatingJob = false;

                    if (ret?.fullName == null) {
                        return;
                    }

                    void this._router.navigate(['/', 'report', 'runs']);
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }
}
